import { useCallback, useEffect, useState } from "react";
import { VerifyAdmin } from "./VerifyAdmin"
import { RequestView } from "../../firestore/Types/RequestSchema";
import { getAllActiveRequests } from "../../firestore/Functions/requestFunction";
import { useAuth } from "../../contexts/auth/AppAuthContext";
import { SearchBar } from "../../components/SearchBar";
import { RequestRow } from "../../components/RequestRow";
import { LoggedInLayoutSelector } from "../../Layouts/LoggedInLayoutSelector";

export function AdminRequests() {
    const [requests, setRequests] = useState<RequestView[]>([]);
    const [searchValue, setSearchValue] = useState<string>("");
    const {currentUser} = useAuth();

    const refreshRequests = useCallback( async () => {
        // fetch requests from firestore
        const Requests = await getAllActiveRequests().catch((error) => {});
        setRequests(Requests?? []);
    }, []);

    useEffect(() => {
        document.title = 'Admin Requests';
        refreshRequests();
    }, [currentUser, refreshRequests]);

    return (
        <LoggedInLayoutSelector>
            <VerifyAdmin />
            <div className='main-bg min-h-[90vh] flex flex-row'>
                <div className='flex h-full w-[80%] mx-[10%]'>
                    <h1 className="text-2xl font-bold">Pending Requests</h1>
                    <div className="flex flex-row w-full">
                        <div className="flex flex-col rounded-lg border-solid border-2 my-2 p-2 mx-6 border-gray-300 w-[280px] h-[500px]">
                            <SearchBar setSearchValue={setSearchValue} />
                            <br></br>
                        </div>
                        <div className="overflow-visible w-[80%]">
                            {requests.filter(request => request.Type.includes(searchValue) || request.Status.includes(searchValue) || request.Type.includes(searchValue)).map((request, index) => <RequestRow request={request} key={index} />)}
                            {requests.length === 0 && <div className="text-center">No requests found</div>}
                        </div>
                    </div>
                </div>
            </div>
        </LoggedInLayoutSelector>
    );
}